import { createContext, ReactNode } from 'react';
import { MenuRoute } from '../Menu/types';
import { NavigationDirection, NavigationRequest } from './hooks';

export interface MenuContextType {
    path: string[];
    activeView: ReactNode | null;
    direction: NavigationDirection;
    animationKey: number;
    routes: MenuRoute[];
    routesById: Map<string, MenuRoute>;
    navigationRequest: NavigationRequest | null;
    navigateTo: (label: string, view?: ReactNode) => void;
    navigateById: (id: string, ...args: unknown[]) => void;
    navigateByPath: (path: string[]) => void;
    setNavigationRequest: (request: NavigationRequest | null) => void;
    goBack: () => void;
    reset: () => void;
    getRouteById: (id: string) => MenuRoute | undefined;
    getRoutesByPath: (path: string[]) => MenuRoute[];
    getChildRoutes: (parentPath: string[]) => MenuRoute[];
    registerRoutes: (routes: MenuRoute[]) => void;
}

export const MenuContext = createContext<MenuContextType | null>(null);
